import {NassauLog} from "../../scripts/myga-utils.js";
import {mygaSession} from "../../scripts/myga-session";

const defaultTestData = {
  enabled: false,
  actionList: [
    {
      type: 'GET',
      value: (window.location.href.indexOf('localhost') !== -1) ?
        window.location.href.replace('localhost', '127.0.0.1') :
        window.location.href
    }
  ],
  stagedActionList: {}
}

const TEST_EVENTS = Object.freeze({
  SET_TEST_MODE: 'SET_TEST_MODE'
})

const getTestSessionData = () => mygaSession.getMygaSessionValue('testData', defaultTestData)

const setTestSessionValue = async (key, value) => {
  let session = getTestSessionData()
  session[key] = value
  mygaSession.setMygaSessionValue('testData', session)
}

const resetTestSessionData = async () => {
  await mygaSession.setMygaSessionValue('testData', defaultTestData)
}

const getTestModeEnabled = () => {
  let session = getTestSessionData()
  return session.enabled
}

const setTestModeEnabled = async flag => {
  let session = getTestSessionData()
  if (!session.enabled && flag === true) session.actionList = defaultTestData.actionList
  session.enabled = flag
  session.disableAfterNextCommit = false;
  await mygaSession.setMygaSessionValue('testData', session)
  mygaSession.eventEmitter.emit(TEST_EVENTS.SET_TEST_MODE)
}

const disableAfterNextCommit = async () => {
  let session = getTestSessionData()
  session.disableAfterNextCommit = true;
  await mygaSession.setMygaSessionValue('testData', session)
}

const getTestActionList = () => {
  let session = getTestSessionData()
  return session.actionList
}

const setTestActionList = async newList => {
  await setTestSessionValue('actionList', newList)
}

const getTestStagedActionList = () => {
  let session = getTestSessionData()
  return session.stagedActionList
}

const setTestStagedActionList = async newList => {
  await setTestSessionValue('stagedActionList', newList)
}

const pushToTestActionList = async newVal => {
  let list = getTestActionList()
  list.push(newVal)
  await setTestActionList(list)
}

const handleClick = async e => {

  // Handle click events for svg's
  if (e.target.classList[0] === undefined && e.target.viewportElement !== undefined) e.target = e.target.viewportElement

  if (e.target.classList.contains('test-enabled')) {
    await pushToTestActionList({
      "type": "CLICK_ELE_BY_ID",
      "id": e.target.id
    })
  }
}

// list is expected to be an array of (page, type, id, and value) objects
const stageManualActionList = async list => {
  for (let i=0; i<list.length; i++) {
    let action
    let item = list[i]
    switch (item.type) {
      case 'keys':
        action = {
          type: 'SEND_KEYS',
          id: item.id,
          value: item.value
        }
        break

      case 'click':
        action = {
          type: 'CLICK_ELE_BY_ID',
          id: item.id
        }
        break

      case 'wait':
        action = {
          type: 'WAIT_UNTIL_ELE_ID_LOCATED',
          id: item.id,
          timeout: item.timeout
        }
        break

      case 'sleep':
        action = {
          type: 'SLEEP',
          value: item.value
        }
        break

      default:
        NassauLog(`Handle State: action not supported: ${JSON.stringify(item,null,2)}`)
    }
    if (action !== undefined) {
      let stagedData = getTestStagedActionList()
      let stagedId = item.stagedId !== undefined ? item.stagedId : item.id
      stagedData[stagedId] = action
      await setTestStagedActionList(stagedData)
    }
  }
}

const handleTestEvent = async (field, e, value) => {
  let stagedData = getTestStagedActionList()

  if (e.target) {
    //NassauLog(`${field} with id: ${e.target.id} changed to ${value}`)
    stagedData[field] = {
      "type": "CLICK_ELE_BY_ID",
      "id": e.target.id
    }
  } else {
    //NassauLog(`${field} changed to ${value}`)
    stagedData[field] = {
      type: 'SEND_KEYS',
      id: field,
      value: value
    }
  }

  //NassauLog(`staged action list: ${JSON.stringify(stagedData, null, 2)}`)
  await setTestStagedActionList(stagedData)
}

const commitStagedActionList = async (page='') => {
  let stagedActionList = Object.values(getTestStagedActionList())
  for (let i=0; i<stagedActionList.length; i++) {
    stagedActionList[i] = {...stagedActionList[i],page}
    await pushToTestActionList(stagedActionList[i])
  }
  await setTestStagedActionList({})
  let session = getTestSessionData()
  if (session.disableAfterNextCommit) {
    await setTestModeEnabled(false);
  }
}

const handleNextBtnEvent = async (page='') => {
  await pushToTestActionList({
    page,
    type: 'CLICK_ELE_BY_ID',
    id: 'nextBtn',
  })
  await pushToTestActionList({
    page,
    type: 'WAIT_UNTIL_STORAGE_KEY_HAS_NEW_VALUE',
    key: 'CurrPage',
    currentValue: page
  })
}

const handlePrevBtnEvent = async (page='') => {
  await pushToTestActionList({
    page,
    type: 'CLICK_ELE_BY_ID',
    id: 'prevBtn',
  })
  await pushToTestActionList({
    page,
    type: 'WAIT_UNTIL_STORAGE_KEY_HAS_NEW_VALUE',
    key: 'CurrPage',
    currentValue: page
  })
}

const handleTestField = (type, id, field, initialField, actionList, stagedId) => {
  if (field !== initialField) {
    let action = {
      type,
      id,
      value: field
    }
    if (stagedId !== undefined) action.stagedId = stagedId
    actionList.push(action)
  }
  return actionList
}

let GENERATOR = {
  handleClick,
  stageManualActionList,
  handleTestEvent,
  setTestModeEnabled,
  getTestModeEnabled,
  commitStagedActionList,
  disableAfterNextCommit,
  resetTestSessionData,
  handleNextBtnEvent,
  handlePrevBtnEvent,
  getTestActionList,
  TEST_EVENTS,
  handleTestField
}

export default GENERATOR